import { render } from "./BaseRatings.vue?vue&type=template&id=a2ba9e60&scoped=true"
import script from "./BaseRatings.vue?vue&type=script&lang=js"
export * from "./BaseRatings.vue?vue&type=script&lang=js"

import "./BaseRatings.vue?vue&type=style&index=0&id=a2ba9e60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ba9e60"]])

export default __exports__